"use strict";

class Utils {
  constructor() {}

  static formatTime(date) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();

    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();

    return [[year, month, day]
        .map(this.formatNumber)
        .join("-")];

    return [
      [year, month, day].map(this.formatNumber).join("-"),
      [hour, minute].map(this.formatNumber).join(":")
    ];
    return [
      [year, month, day].map(this.formatNumber).join("-"),
      [hour, minute, second].map(this.formatNumber).join(":")
    ];
  }

  static formatTime2(date) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();

    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();

    return [
      [year, month, day].map(this.formatNumber).join("-"),
      " "+[hour, minute].map(this.formatNumber).join(":")
    ];
    return [
      [year, month, day].map(this.formatNumber).join("-"),
      [hour, minute, second].map(this.formatNumber).join(":")
    ];
  }

  static formatLogTime(date) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();

    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();

    return [
      [year, month, day].map(this.formatNumber).join(""),
      [hour, minute, second].map(this.formatNumber).join("")
    ];
  }

  static formatNumber(n) {
    n = n.toString();
    return n[1] ? n : "0" + n;
  }

  static getTimestamp(stringTime) {
    var _stringTime = stringTime.replace(/\-/g, "/");
    var timestamp2 = Date.parse(new Date(_stringTime));
    timestamp2 = timestamp2 / 1000;
    return timestamp2;
  }

  static rpxToPx(rpx) {
    return (rpx * Utils.systemInfo.windowWidth) / 750;
  }

  static pxToRpx(px) {
    return px / (Utils.systemInfo.windowWidth / 750);
  }

  static imageMogr(size) {
    return `imageslim`;
    return `imageMogr2/thumbnail/${size}x${size}>/interlace/1`;
  }

  static checkPhoneNum(phone) {
    if (/^1\d{10}$/.test(phone)) {
      return true;
    } else {
      return false;
    }
  }

  static trim(s) {
    return s.replace(/(^\s*)|(\s*$)/g, "");
  }

  static messageInfo(info) {
      message.destroy()
      message.info(info)
  }

  static messageError(error) {
      message.destroy()
      message.info(error)
  }

  static formatSeconds(value) {
    var theTime = parseInt(value); // 秒

    var theTime1 = 0; // 分

    var theTime2 = 0; // 小时

    if (theTime > 60) {
      theTime1 = parseInt(theTime / 60);

      theTime = parseInt(theTime % 60);

      if (theTime1 > 60) {
        theTime2 = parseInt(theTime1 / 60);

        theTime1 = parseInt(theTime1 % 60);
      }
    }

    var result = "" + parseInt(theTime) + "秒";

    if (theTime1 > 0) {
      result = "" + parseInt(theTime1) + "分" + result;
    }

    if (theTime2 > 0) {
      result = "" + parseInt(theTime2) + "小时" + result;
    }

    return result;
  }

    static replaceAlbumName(list) {
        list.map((item, index) => {
            item.title = item.title.replace(/[&\|\\\*^/%$#"'·@\-:?<>\s]/g, '')
            item.nickname = item.nickname.replace(/[&\|\\\*^/%$#"'·@\-:?<>\s]/g, '')
        })
        return list
    }

}

export default Utils



// WEBPACK FOOTER //
// ./src/common/Utils.js